<micro-select-combo #sel
              placeholder="Queue Config"
              routerBase="q/queueConfigs"
              [mode]="mode"
              [(id)]="queueConfigId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              platformService="qd"
>
</micro-select-combo>
